module.exports = __webpack_public_path__ + "media/images/emblems/Muelligen-blason-6aca3677f8c16b5ff355599545b21435.svg";